import { AnalyticsFeature } from '@domain/features/analytics/analytics-feature'

export class UserAnalyticsFeature {
  public static trackAuthLoginSuccess(screenPath: string): void {
    AnalyticsFeature.trackAuthLoginSuccess(screenPath, 'auth_modal')
  }

  public static trackAuthSignupSuccess(screenPath: string): void {
    AnalyticsFeature.trackAuthSignupSuccess(screenPath, 'auth_modal')
  }

  public static trackAuthResetSuccess(screenPath: string): void {
    AnalyticsFeature.trackAuthResetSuccess(screenPath, 'auth_modal')
  }

  public static trackAuthLogout(
    screenPath: string,
    isAuthenticated?: boolean,
  ): void {
    AnalyticsFeature.trackAuthLogout(screenPath, 'user_profile_modal', isAuthenticated)
  }

  public static trackProfileNameSave(
    screenPath: string,
    isAuthenticated?: boolean,
  ): void {
    AnalyticsFeature.trackProfileNameSave(screenPath, 'user_profile_modal', isAuthenticated)
  }

  public static trackProfilePhotoUpload(
    screenPath: string,
    isAuthenticated?: boolean,
  ): void {
    AnalyticsFeature.trackProfilePhotoUpload(
      screenPath,
      'user_profile_modal',
      isAuthenticated,
    )
  }
}
